<template>
  <div class="col-12  mt-4">

    <h4 class="stage-results__subtitle">{{'protocol.pecs.control_of_achievements' | trans}} <span v-if="teachingMethod == 7">{{session.stage.description}}:</span> <span class="nowrap">{{toLocaleDate(session.day)}}</span></h4>
    <div class="row" v-if="isRowData">
      <div class="col-12 mt-3" v-for="dataProp in session.rowData">
          <h4 class="stage-results__subtitle">{{'protocol.categoryTitle' | trans}}: {{dataProp.title}}.</h4>

          <div class="row" v-for="stimul in dataProp.stimuli">
            <div class="col-12">

              <h4 class="stage-results__subtitle"><span class="text-capitalize">{{dataProp.typeId == 2 ? 'protocol.subjects' : 'protocol.property' | trans}}</span>: {{stimul.description}}</h4>

              <table class="stage-results-table table table-sm" v-if="stimul.result.length">
                <thead class="thead-light">
                <tr>
                  <th class="pl-3">
                    {{'protocol.number_of_trials' | trans}}
                  </th>
                  <th class="text-center">
                    {{'protocol.compliance_check' | trans}}
                  </th>
                  <th class="text-capitalize">{{'protocol.property' | trans}} <span v-if="teachingMethod == 10 && dataProp.typeId != 2"> / {{'protocol.subjects' | trans}}</span></th>
                </tr>
                </thead>
                <tbody>

                  <tr v-for="(taskData, index) in stimul.result">
                    <td class="pl-3">
                      <span v-if="teachingMethod != 10">{{index + 1}}</span>
                      <span v-if="teachingMethod == 10">{{taskData.sessionIndex}}.{{taskData.iterationIndex}}</span>
                    </td>
                    <td class="text-center">
                      {{taskData.title | trans}}
                    </td>
                    <td>
                      <span v-for="task in taskData.stimuli" class="mr-2">{{task}}</span>
                    </td>
                  </tr>

                </tbody>

              </table>

            </div>
          </div>


          <h5 class="text-center" v-if="!dataProp.stimuli.length">{{'bids.no_data' | trans }}</h5>
        </div>
      </div>

    <div class="row" v-if="!isRowData">
      <div class="col-12">
         <table class="stage-results-table table table-sm" v-if="!isMobile">
          <thead class="thead-light">
          <tr>
            <th class="text-center">
              {{'protocol.attempt' | trans}}
            </th>
            <th v-for="stimul in session.stimuli" class="text-center">
              {{stimul}}
            </th>
          </tr>

          </thead>

          <tbody>
          <tr v-for="(row, index) in session.data" class="text-center">
            <td>
              {{index + 1}}
            </td>
            <td  v-for="cell in row">
              <span v-if="cell.isCustomized">
                {{cell.title}}
              </span>
              <span v-if="!cell.isCustomized">
                {{cell.title | trans}}
              </span>
            </td>
          </tr>

          </tbody>

        </table>

        <div class="mobile-table"  v-if="isMobile">
          <div class="mobile-table__body" v-if="session.data.length">

            <div :key="index"
                 class="mobile-table__row"
                 v-for="(row, index) in session.data">
              <div class="mobile-table__head">
                {{'protocol.attempt' | trans}} {{index + 1}}
              </div>

              <div class="description">
                <p v-for="(cell, index) in row" class="mt-2">
                  {{session.stimuli[index]}} -
                  <span v-if="cell.isCustomized">
                  {{cell.title}}
                </span>
                  <span v-if="!cell.isCustomized">
                  {{cell.title | trans}}
                </span>
                </p>

              </div>
            </div>
          </div>
          <h5 class="text-center" v-if="!session.data.length">{{'bids.no_data' | trans }}</h5>
        </div>
      </div>
    </div>

  </div>


</template>
<script>
  import moment from 'moment';
  import lang from '../../../lang/translator';
  import {mapGetters} from 'vuex';
  import filter from 'lodash/filter';
  import {typeProtocol} from '../../../common/mixins/typeProtocol';

  export default {

    props: [
      'session',
      'teachingMethod',
      'isRowData'
    ],
    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },
    mixins: [typeProtocol],
    methods:{
      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },
      trans: function (key) {
        return lang.get(key);
      },
      answerTitle: function (answer, last) {
        let title = filter(last.answers, item => {
          return item.id == answer
        });

        return title.length ? title[0]['title'] : '';
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/modules/dashboardParent/components/LastSessionPecsResults.vue